/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import debug from "../util/Debug";

const responseHandler = (output, parser = null, args = {}) => {
  const { error, response } = output;

  // return error if exists
  if (error) {
    return { error: error };
  }

  // process results if handler available
  if (parser != null) {
    return parser({...args, response: response});
  }

  // no parsing available
  return {};
};

const makeRequest = ({
  context,
  request, 
  requests,
  onSuccess,
  onFailure,
  showLoading = true,
}) => {
  // validate inputs
  if (requests && request) {
    debug.error("makeRequest(): 'requests' and 'request' cannot both be non-null");
    return;
  }

  if (!requests && !request) {
    debug.error("makeRequest(): 'requests' and 'request' cannot both be null");
    return;
  }

  // process requests
  const processRequest = (request) => {
    const { route, token, payload = {}, form, parser } = request;
    const handler = (response) => responseHandler(response, parser);
    return { route, token, payload, form, handler };
  };

  const requestsToProcess = requests ?? [request];
  const processedRequests = requestsToProcess.map(request => processRequest(request));

  // update request context
  context({
    request: {
      handleSuccess: onSuccess,
      handleFailure: onFailure,
      showLoading: showLoading,
      requests: processedRequests,
    }
  });
}

export default makeRequest;
